import React from 'react';

import {
  Flex,
  Text,
} from 'web-styled';

import {
  Tooltip,
} from 'web-components';

import * as S from './styled';

const getpercentage = (completed, total) => {
  const percentage = (completed / total) || 0;
  const value = percentage * 20;
  return parseInt(value, 10);
};

const tooltipText = {
  indicator: 'This part gives you an overview of your performance for the current week',
};

type Props = {
  text: string,
  total: number,
  completed: number,
  isClient: boolean,
};

const Indicator = ({
  text,
  total,
  isClient,
  completed,
}: Props) => (
  <Tooltip
    body={tooltipText.indicator}
    preferPlace="above"
    width="190px"
  >
    <Flex
      width="180px"
      height="180px"
      align="center"
      justify="center"
    >
      <S.Indicator>
        <S.Stroke />
        <S.ActiveStroke
          isClient={isClient}
          percentage={getpercentage(completed, total)}
        />
      </S.Indicator>
      <S.Content>
        <Text
          color="#757575"
          size="40px"
          lineHeight="40px"
        >
          {isClient ? `${completed}/${total}` : `${completed || 0}`}
        </Text>
        <Text
          size="10px"
          color="#757575"
          align="center"
          lineHeight="11px"
          whiteSpace="pre-line"
        >
          {text}
        </Text>
      </S.Content>
    </Flex>
  </Tooltip>
);

export default Indicator;
